export default "__VITE_ASSET__CCab9zxI__"